import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Text, Divider } from "@chakra-ui/react";
const UserSelectionsSummary = ({ time, maleCount, femaleCount, isNewTableFormat, onChangeClick, }) => {
    const formatTime = (timeString) => {
        if (!timeString)
            return "";
        const date = new Date(timeString);
        return date.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
    };
    const getGuestText = () => {
        const total = maleCount + femaleCount;
        if (maleCount === 0 && femaleCount > 0) {
            return `${femaleCount} Ladies`;
        }
        else if (femaleCount === 0 && maleCount > 0) {
            return `${maleCount} Stag`;
        }
        else if (maleCount > 0 && femaleCount > 0) {
            return `${femaleCount} Ladies, ${maleCount} Stag`;
        }
        return `${total} Guests`;
    };
    const dateObj = new Date(time);
    const dateText = dateObj.toLocaleDateString("en-US", {
        weekday: "short",
        day: "2-digit",
        month: "short",
    });
    const timeText = dateObj.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });
    return (_jsx(Flex, { w: "100%", justify: "center", align: "center", children: _jsxs(Flex, { bg: "#1A1A1A", border: "1px solid #414141", borderRadius: "full", px: 6, py: isNewTableFormat ? 1 : 2, align: "center", justify: "space-between", color: "white", minW: "250px", onClick: onChangeClick, children: [_jsxs(Flex, { direction: "column", align: "flex-start", children: [_jsx(Text, { fontSize: "12px", fontWeight: "400", color: "#FFFFFF", children: dateText }), _jsx(Text, { fontSize: "10px", fontWeight: "400", color: "#9D9D9D", children: timeText })] }), _jsx(Divider, { orientation: "vertical", h: "35px", borderColor: "#616161", mx: 4 }), _jsxs(Flex, { direction: "column", align: "flex-start", children: [_jsx(Text, { fontSize: "12px", fontWeight: "400", color: "#FFFFFF", children: getGuestText() }), _jsxs(Text, { fontSize: "10px", fontWeight: "400", color: "#9D9D9D", children: [maleCount + femaleCount, " Guests"] })] })] }) }));
};
export default UserSelectionsSummary;
